import React from "react";
import { formatTimestamp } from "../../hooks/time-buckets";

export default function TableWidget({ data, granularity, columns = 2 }) {
    if (!data || data.length === 0) {
        return <div className="empty-chart">No data</div>;
    }

    const rows = [...data]
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        .slice(0, 20);

    return (
        <table style={{ width: "100%", fontSize: "0.85rem", borderCollapse: "collapse" }}>
            <thead>
                <tr>
                    <th style={{ textAlign: "left", padding: "4px 8px", borderBottom: "1px solid #e2e8f0" }}>
                        Time
                    </th>
                    <th style={{ textAlign: "right", padding: "4px 8px", borderBottom: "1px solid #e2e8f0" }}>
                        Value
                    </th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, i) => (
                    <tr key={i}>
                        <td style={{ padding: "3px 8px", color: "#64748b" }}>
                            {formatTimestamp(row.timestamp, granularity)}
                        </td>
                        <td style={{ padding: "3px 8px", textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                            {Number(row.value).toLocaleString()}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
